






















































import { Component, Mixins } from 'vue-property-decorator'
import { Meta } from '@/helpers/decorators'

// Helpers
import { downloadFileUrl } from '@/helpers/download'

// Mixins
import Contact from '@/mixins/Contact'
import Router from '@/mixins/Router'

// Components
import Box from '@/components/common/Box.vue'


@Component({
  components: { Box }
})
export default class ItemImportHelp extends Mixins(Contact, Router) {

  downloadCsv(path, name) {
    downloadFileUrl(`${name}.csv`, `${process.env.VUE_APP_BASE_URL}/${path}`)
  }

  @Meta
  metas() {
    return {
      title: this.$t('menu.fleet'),
      titleTemplate: `%s - ${process.env.VUE_APP_NAME}`
    }
  }
}
